import { createIcon } from '@chakra-ui/react';

export const RecoupledIcon = createIcon({
  displayName: 'RecoupledIcon',
  viewBox: '12 12 24 24',
  defaultProps: {
    fill: 'none',
    height: '4',
    width: '4',
  },
  path: (
    <>
      <path
        d="M13.1 17.0714H13.9C13.9552 17.0714 14 17.1162 14 17.1714V18.6857C14 18.7409 13.9552 18.7857 13.9 18.7857H13.1C13.0448 18.7857 13 18.7409 13 18.6857V17.1714C13 17.1162 13.0448 17.0714 13.1 17.0714Z"
        stroke="currentColor"
      />
      <path
        d="M13.1 22.2143H13.9C13.9552 22.2143 14 22.2591 14 22.3143V23.8286C14 23.8838 13.9552 23.9286 13.9 23.9286H13.1C13.0448 23.9286 13 23.8838 13 23.8286V22.3143C13 22.2591 13.0448 22.2143 13.1 22.2143Z"
        stroke="currentColor"
      />
      <path
        d="M22 15.5V15.8846V25.5C22 26.0523 21.5523 26.5 21 26.5H18H15C14.4477 26.5 14 26.0523 14 25.5V15.5C14 14.9477 14.4477 14.5 15 14.5H21C21.5523 14.5 22 14.9477 22 15.5Z"
        stroke="currentColor"
        strokeWidth="1.6"
        fill="none"
      />
      <path
        d="M20.6 29.6765C19.7163 29.6765 19 28.8337 19 27.7941L19 18.3824C19 17.3428 19.7163 16.5 20.6 16.5L33.4 16.5C34.2837 16.5 35 17.3428 35 18.3824V27.7941C35 28.8337 34.2837 29.6765 33.4 29.6765H20.6Z"
        fill="white"
      />
      <path
        d="M31.1094 30.5596C31.7277 30.5597 32.2275 31.0617 32.2275 31.6797C32.2275 32.2977 31.7277 32.7997 31.1094 32.7998H21.291C20.6727 32.7997 20.1729 32.2977 20.1729 31.6797C20.1729 31.0617 20.6727 30.5597 21.291 30.5596H31.1094ZM32.7461 16.2002C34.2991 16.2004 35.4998 17.4908 35.5 19.0098V27.457C35.4996 28.976 34.2989 30.2654 32.7461 30.2656H19.6543C18.1015 30.2654 16.9008 28.976 16.9004 27.457V19.0098C16.9006 17.4908 18.1013 16.2004 19.6543 16.2002H32.7461ZM19.5586 18.4512C19.3363 18.499 19.1359 18.7093 19.1357 19.0098V27.457C19.1361 27.7998 19.3971 28.0252 19.6543 28.0254H32.7461L32.8418 28.0146C33.0641 27.9669 33.2643 27.7571 33.2646 27.457V19.0098C33.2645 18.7093 33.0641 18.499 32.8418 18.4512L32.7461 18.4404H19.6543L19.5586 18.4512Z"
        fill="currentColor"
        stroke="white"
        strokeWidth="0.6"
        strokeLinecap="round"
      />
    </>
  ),
});
